import getStartOfDay from '../get-start-of-day';

export const isSameDay = (firstDate: Date | number, secondDate: Date | number): boolean => {
  const firstFormattedDate = getStartOfDay(firstDate);
  const secondFormattedDate = getStartOfDay(secondDate);

  return firstFormattedDate.getTime() === secondFormattedDate.getTime();
};

export default isSameDay;
